// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__GtFkC","card":"index_card__3QosN","logo":"index_logo__1Q7YM"};